<template>
    <form-field>
        <input-dropzone
            :url="'/api/settings/settings/' + setting.id"
            v-if="(setting.id > 0)"
            @success="uploaded"
            clickable
        />
        <div v-if="setting.type === 'image'" class="file-container">
            <img
                :src="'data:image/png;base64,' + setting.value"
            >
        </div>
        <div v-if="filename" class="file-container">
            <p>{{ filename }}</p>
            <div class="file-delete" @click="deleteFile">
                <span class="icon"><i class="fas fa-trash"/></span>
            </div>
        </div>
    </form-field>
</template>

<script>
    import { FormField, InputDropzone } from '@elems/form'

    export default {
        components: {
            FormField,
            InputDropzone
        },

        props: {
            label: String,
            skey: String,
            hasIcon: {
                type: Boolean,
                default: true,
            },
            isBoolean: {
                type: Boolean,
                default: false,
            }
        },

        computed: {
            setting() {
                return this.$store.getters.settingByKey(this.skey) || {}
            },
            filename() {
                return this.setting.type === 'file' && this.setting.value ? this.setting.value.filename : '';
            }
        },
        methods: {
            uploaded(file, response) {
                this.$store.dispatch('updateSetting', response)
            },
            deleteFile() {
                if (!confirm('Er du sikker på du vil slette filen?')) {
                    return
                }

                window.axios.delete('/api/settings/settings/' + this.setting.id)
                    .then(({data}) => {
                        this.$store.dispatch('updateSetting', data)
                        this.toggleSuccess()
                        this.error = []
                    })
                    .catch(error => {
                        if (error.response) {
                            this.error = error.response.data.errors
                        }
                    })
            }
        }

    }
</script>

<style lang="scss" scoped>
    .file-container {
        display: flex;
        justify-content: center;
        gap: 0.5rem;
        padding: 10px;

        p {
            font-weight: bold;
        }
        img {
            border: 1px solid #000;
            width: 80%;
        }

        .file-delete {
            cursor: pointer;
        }
    }

</style>
